export default __webpack_public_path__ + "static/media/depannage-a-distance-min.3d9b65c2.jpg";